import { faEdit, faTrashAlt } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { type CellContext } from '@tanstack/react-table';
import { useIntl } from 'react-intl';

import { type PointsGroup } from 'src/features/parkingManagement/types/pointsGroup.ts';
import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/utils/messages';

interface CellPointsGroupProps<TData, TValue> extends CellContext<TData, TValue> {
    deleteCallback: (point: TData) => void;
    editCallback: (point: TData) => void;
    tooltipMessage: { id: string; defaultMessage: string };
}
export default function CellPointsGroupActions({
    deleteCallback,
    editCallback,
    tooltipMessage,
    row,
}: CellPointsGroupProps<PointsGroup, unknown>) {
    const { formatMessage } = useIntl();

    return (
        <div className="ml-auto flex max-w-24 gap-1">
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Button
                            onClick={() => editCallback(row.original)}
                            size="icon"
                            variant="link"
                            className="hover:bg-gray-100"
                        >
                            <FontAwesomeIcon icon={faEdit} />
                        </Button>
                    </TooltipTrigger>
                    <TooltipContent>
                        {`${formatMessage(generalMessages.edit)} ${formatMessage(tooltipMessage).toLocaleLowerCase()}`}
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Button
                            onClick={() => deleteCallback(row.original)}
                            size="icon"
                            variant="link"
                            className="hover:bg-gray-100"
                        >
                            <FontAwesomeIcon icon={faTrashAlt} />
                        </Button>
                    </TooltipTrigger>
                    <TooltipContent>
                        {`${formatMessage(generalMessages.delete)} ${formatMessage(tooltipMessage).toLocaleLowerCase()}`}
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
